module.exports = {
	data() {
		return {
			errors: {},
			labels: [],
			maps: {
            	location: null,
            	address: '',
            	map: null,
            	infowindow: null,
            	bounds: null,
            	geocoder: null,
            	autocomplete: null,
            	directionsService: null,
            	markers: [],
            	directionsRenderers: [],
            	icons: {
            		default: null,
            		hover: null
            	}
            },
            mobileFilterActive: false,
            updatingFilters: false,
            hasLocationInput: true,
            affiliations: hpd_helper.affiliations,
            default_affiliation: hpd_helper.default_affiliation
		}
	},

	watch: {
		mobileFilterActive(val) {
			if (val) {
				let props = Object.keys(this.temp);

				for (let i=0; i<props.length; i++) {
					Vue.set(this.temp, props[i], this.query[props[i]]);
				}
			}
		}
	},

	computed: {
		//
	},

	created() {
		this.labels = theme.labels;
	},

	methods: {
		/**
		 * Returns a promise to GET a request (for public routes)
		 *
		 * @param  string  url  The URL to get
		 */
		getData(url = '') {
			return fetch(url, {
				headers: {
					'Accept': 'application/json'
				},
				credentials: 'same-origin'
			})
			.then(this.handleCommonResponseErrors)
			.then(response => response.json())
			.catch(error => console.log(error))
		},

		/**
		 * Returns a promise to POST a request
		 *
		 * @param  string  url     The URL to post
		 * @param  JSON    data    The JSON data to include
		 * @param  string  method  Type of request
		 */
		postJson(url = '', data = {}, method = 'POST') {
			return fetch(url, {
				method: method,
				body: JSON.stringify(data),
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json; charset=utf-8'
				},
				credentials: 'same-origin'
			})
			.then(response => response.json())
			.then(this.handleCommonResponseErrors)
			.catch(error => console.log(error));
		},

		/**
		 * Handle responses when the user is no longer authorized (session expired)
		 */
		handleCommonResponseErrors(response) {
			return response;
		},

		/**
		 * Listen to filter trigger clicks
		 */
		handleFilterTriggers() {
			var self = this;

			//Handle trigger clicks (easier with script than vue)
            $('.trigger .button').click(function(e) {
                //Get the property to set
                let prop = $(this).parent().find('input').prop('name');

                if (prop.substr(-2) == '[]') {
                	prop = prop.slice(0, -2);
                }

                //Set the temp to match what's currently selected
                Vue.set(self.temp, prop, self.query[prop]);

                //If this is currently active, close it
                if ($(this).parent().hasClass('active')) {
                    $(this).closest('.trigger').removeClass('active');
                    $('.inline-modal-overlay').removeClass('active');
                    //$('body').removeClass('no-scroll');
                }
                //If there are other guys open, close them
                //Open this one
                else {
                    $('.trigger.active').removeClass('active');

                    $(this).closest('.trigger').addClass('active');
                    $('.inline-modal-overlay').addClass('active');
                    //$('body').addClass('no-scroll');
                }
            });

            //Update the appropriate item and close the popup
            $('.trigger .popup .confirm').click(function(e) {
                //Get the property to set
                let prop = $(this).closest('.popup').find('input').prop('name');

                if (prop.substr(-2) == '[]') {
                	prop = prop.slice(0, -2);
                }

                //Update the query
                Vue.set(self.query, prop, self.temp[prop]);

                //Now close the modal
                $(this).closest('.trigger').removeClass('active');
                $('.inline-modal-overlay').removeClass('active');
                //$('body').removeClass('no-scroll');
            });

            //If the background is clicked, close the filtro
            $('.inline-modal-overlay').click(function(e) {
            	$('.trigger').removeClass('active');
            	$('.inline-modal-overlay').removeClass('active');
                $('body').removeClass('no-scroll');
            });
		},

		toggleMobileFilter() {
			this.mobileFilterActive = !this.mobileFilterActive;
			$('body').toggleClass('no-scroll');
		},

		closeFilter() {
			this.mobileFilterActive = false;
			$('body').removeClass('no-scroll');
		},

		applyFilters() {
			this.updatingFilters = true;

			let props = Object.keys(this.temp);

			for (let i=0; i<props.length; i++) {
				Vue.set(this.query, props[i], this.temp[props[i]]);
			}

			this.updatingFilters = false;

			this.closeFilter();

			this.getResults();
		},

		/**
		 * Format kilometers from a float
		 *
		 * @param  float  distance  A distance in kilometers
		 *
		 * @return string  			The formatted distance
		 */
		formatKM(distance) {
			return Math.ceil(distance)+' KM';
		},

		initMap() {
			//Draw the map, centered on current location
			this.maps.map = new google.maps.Map(document.getElementById('map'), {
                zoom: 12,
                center: {
                    lat: this.maps.location.lat,
                    lng: this.maps.location.lng
                },
                mapTypeControl: false,
                mapId: '1cf3a17a1a9aca56'
            });

            //Create infowindow
            this.maps.infowindow = new google.maps.InfoWindow({
            	content: ''
            });

            //Create markers
            this.maps.icons.default = {
            	url: theme.maps.pinUrl,
            	size: new google.maps.Size(23,30),
            	scaledSize: new google.maps.Size(23,30)
            };

            this.maps.icons.hover = {
            	url: theme.maps.altPinUrl,
            	size: new google.maps.Size(23,30),
            	scaledSize: new google.maps.Size(23,30)
            };

            //Track its marker
            this.maps.infowindow.marker = null;

			//Init geocoder and fill out address
			if (this.hasLocationInput) {
	            this.maps.geocoder = new google.maps.Geocoder;

	            this.geocodeLocation();

	            //Init the autocomplete
	            let addressField = document.getElementById('address');

	            //Submit on enter
	            this.pacSelectFirst(addressField);

	            //Init
	            this.maps.autocomplete = new google.maps.places.Autocomplete(
	                addressField,
	                {
	                    componentRestrictions: {'country': 'ca'}
	                }
	            );

	            //Listen for address change
	            this.maps.autocomplete.addListener('place_changed', ((e) => {
	                let place = this.maps.autocomplete.getPlace();

	                if (place) {
	                	Vue.set(this.maps, 'location', {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()});
	                	Vue.set(this.maps, 'address', place.formatted_address);
	                }
	            }));
			}
			//Otherwise initialize the clusterer
			else {
				this.clusterer = new markerClusterer.MarkerClusterer({
	            	map: this.maps.map,
	            	renderer: {
	            		render({count, position}, stats) {
	            			// create svg url with fill color
					        const svg = window.btoa(`
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
									<circle cx="120" cy="120" opacity="1" r="70" fill="#FFFFFF" stroke="#E72C75" stroke-width="5"/>    
								</svg>`
							);

							// create marker using svg icon
					        return new google.maps.Marker({
					            position,
					            icon: {
					                url: `data:image/svg+xml;base64,${svg}`,
					                scaledSize: new google.maps.Size(56, 56),
					                size: new google.maps.Size(56, 56),
					                labelOrigin: new google.maps.Point(28,28)
					            },
					            label: {
					                text: String(count),
					                color: "#E72C75",
					                fontSize: "12px",
					                fontWeight: "900",
					                fontFamily: "GreycliffCF, Helvetica, Arial, Sans-Serif"
					            },
					            // adjust zIndex to be above other markers
					            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
					        });
	            		}
	            	}
	            });
			}

            //Listen for infowindow close
            this.maps.infowindow.addListener('closeclick', ((e) => {
            	//Set the marker back
            	this.setDefaultPin(this.maps.infowindow.marker.refersTo);

            	//Unset the marker
            	this.maps.infowindow.marker = null;
            }));
		},

		updateMap() {
			let self = this;
			this.clearMarkers();

			let parser = new DOMParser();

			if (this.results.posts.length) {
				this.maps.bounds = new google.maps.LatLngBounds();

				this.results.posts.forEach((place) => {
					let affiliationId = place.affiliations && place.affiliations.length ? place.affiliations[0] : parseInt(this.default_affiliation);
					let affiliation = this.affiliations.find((term) => term.term_id == affiliationId);

					let pinSvg = parser.parseFromString(affiliation.pinSvg, 'image/svg+xml').documentElement;
					let hoverPinSvg = parser.parseFromString(affiliation.hoverPinSvg, 'image/svg+xml').documentElement;

					let marker = new google.maps.marker.AdvancedMarkerElement({
						map: this.maps.map,
						position: {lat: place.meta.lat, lng: place.meta.lng},
						content: pinSvg
					});

					//Link marker and place
					marker.refersTo = place;
					place.marker = marker;

					//Store pin info
					marker.pins = {
						initial: pinSvg,
						hover: hoverPinSvg
					}

					this.maps.bounds.extend(marker.position);
					this.maps.markers.push(marker);

					//Show infowindow on click
					google.maps.event.addListener(marker, 'click', function() {
						self.showInfowindow(this);
					});
				});

				//Fit map to new bounds
				this.maps.map.fitBounds(this.maps.bounds);
			}
		},

		clearMarkers() {
			if (this.maps.markers.length) {
				this.maps.markers.forEach((marker) => {
					marker.setMap(null);
				});

				this.maps.markers = [];
			}
		},

		requestUserLocation() {
			if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(((position) => {
                    Vue.set(this.maps, 'location', {lat: position.coords.latitude, lng: position.coords.longitude});

                    this.geocodeLocation();
                }));
            }
            else {
            	this.locateIP();
            }
		},

		locateIP() {
			$.ajax({
				url: 'https://www.googleapis.com/geolocation/v1/geolocate?key='+theme.apiKey,
				data: JSON.stringify({ "considerIp": "true" }),
				type: 'POST',
				contentType: 'application/json',
				success: ((data) => {
					if (data.location) {
						Vue.set(this.maps, 'location', data.location);
					}

					//Init the map, if it's not already set up
					if (!this.maps.map) {
						this.initMap();
					}
				})
			});
		},

		setLocation(lat, lng) {
			Vue.set(this.maps, 'location', {lat, lng});

			if (!this.maps.map) {
				this.initMap();
			}
		},

		geocodeLocation() {
			this.maps.geocoder.geocode({'location': this.maps.location}, ((results, status) => {
                if (status == 'OK') {
                    let city = ''; let province = '';

                    results[0].address_components.some((component) => {
                    	if (component.types.indexOf('locality') >= 0) {
                    		city = `${component.long_name}, `;
                    	}
                    	else if (component.types.indexOf('administrative_area_level_1') >= 0) {
                    		province = component.long_name;
                    	}
                    	else if (component.types.indexOf('county') >= 0) {
                    		province = component.long_name
                    	}

                    	if (city.length && province.length) {
                    		return;
                    	}
                    });

                    this.maps.address = city+province;
                }
            }));
		},

		setHoverPin(post) {
			// post.marker.setIcon(this.maps.icons.hover);
			if (post && post.marker && post.marker.pins) {
				post.marker.content = post.marker.pins.hover;
			}
		},

		setDefaultPin(post) {
			// post.marker.setIcon(this.maps.icons.default);
			if (post && post.marker && post.marker.pins) {
				post.marker.content = post.marker.pins.initial;
			}
		},

		loadPage(page) {
			Vue.set(this.query, 'paged', page);
		},

		/**
		 * After changing pages especially, but whenever a new set of results loads
		 * If you are scrolled lower than the top of the results, scroll back up to it
		 */
		scrollUp() {
			$('html, body, .results').animate({ scrollTop: 0 }, 300);
		},

		showInfowindow(marker) {
			//Don't re-show it
			if (this.maps.infowindow.marker == marker) return;

			//Otherwise, if there is a marker, unhover it
			else if (this.maps.infowindow.marker) {
				this.setDefaultPin(this.maps.infowindow.marker.refersTo);
			}

			//Update infowindow text
			this.setInfowindowContent(marker.refersTo);

			//Open infowindow
			this.maps.infowindow.open(this.maps.map, marker);

			//Track marker
			this.maps.infowindow.marker = marker;

			//Change pin
			this.setHoverPin(marker.refersTo);
		},

		/**
		 * Allow google autocomplete to submit by pressing enter
		 *
		 * @see https://stackoverflow.com/questions/7865446/google-maps-places-api-v3-autocomplete-select-first-option-on-enter/11703018#11703018
		 */
		pacSelectFirst(input) {
			// store the original event binding function
	        var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

	        function addEventListenerWrapper(type, listener) {
	            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
	            // and then trigger the original listener.
	            if (type == "keydown") {
	                var orig_listener = listener;
	                listener = function(event) {
	                    var suggestion_selected = $(".pac-item-selected").length > 0;
	                    if (event.which == 13 && !suggestion_selected) {
	                        var simulated_downarrow = $.Event("keydown", {
	                            keyCode: 40,
	                            which: 40
	                        });
	                        orig_listener.apply(input, [simulated_downarrow]);
	                    }

	                    orig_listener.apply(input, [event]);
	                };
	            }

	            _addEventListener.apply(input, [type, listener]);
	        }

	        input.addEventListener = addEventListenerWrapper;
	        input.attachEvent = addEventListenerWrapper;
		}
	}
};
